import { render, staticRenderFns } from "./HorizonScrollWrap.vue?vue&type=template&id=0fe7a4d1&scoped=true&"
import script from "./HorizonScrollWrap.vue?vue&type=script&lang=js&"
export * from "./HorizonScrollWrap.vue?vue&type=script&lang=js&"
import style0 from "./HorizonScrollWrap.vue?vue&type=style&index=0&id=0fe7a4d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe7a4d1",
  null
  
)

export default component.exports